import { render, staticRenderFns } from "./ListSuhu.vue?vue&type=template&id=305fa853"
import script from "./ListSuhu.vue?vue&type=script&lang=js"
export * from "./ListSuhu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports